import '@/assets/css/linked-cigars.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import React from 'react';
import { connect } from 'react-redux';

import Breadcrumb from '@/components/common/breadcrumb.component';
import { getAllOrders } from '@/redux/actions/shop.actions';

const defaultSorted = [
  {
    dataField: 'name',
    order: 'asc',
  },
];

const cellEditProps = {
  mode: 'dbclick',
};

// FIXME This file, if possible, should allow venue-added gateways to be managed but requires serious PCI compliance and all
class PaymentGatewayTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // TODO https://www.npmjs.com/package/react-device-detect use a different layout for mobile
    return (
      <div>
        {/* <SweetAlert */}
        {/*  show={this.state.message.show} */}
        {/*  type={this.state.message.type} */}
        {/*  title={this.state.message.title} */}
        {/*  onConfirm={this.closeAlert} */}
        {/* > */}
        {/*    {this.state.message.text} */}
        {/* </SweetAlert> */}

        <Breadcrumb
          title="Payment Gateways"
          label="Payment Gateway Config"
          parent="Shop"
        />

        <div className="container-fluid">
          <div className="row">
            <div style={{ marginTop: 30, marginLeft: 16 }}>
              Coming back soon!
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ShopManager }) => ({ ShopManager });

export default connect(mapStateToProps, {
  getAllOrders,
})(PaymentGatewayTable);
